import { rem } from '@lessonup/ui-components';

export const LESSON_TOP_BAR_INNER_HEIGHT = rem('24px');
